import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const isDevelopment = process.env.VUE_APP_ENV === 'development';

// 公共路由
const constantRoutes = [
    {
        path: '/main',
        component: (resolve) => require(['@/views/main'], resolve),
        hidden: true,

  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true,

},
{
    path: '/loginInfo',
    component: (resolve) => require(['@/views/loginInfo'], resolve),
    hidden: true,

},

]

export default new Router({
    mode: 'history', // 去掉url中的#
    base:isDevelopment?'/':process.env.VUE_APP_BASE_API,
    routes: constantRoutes
})
